import { cn } from '@/lib/utils';

interface PropertyTitleProps {
  title: string;
  featured: boolean;
  shouldShowHoverEffects: boolean;
}

export default function PropertyTitle({
  title,
  featured,
  shouldShowHoverEffects,
}: PropertyTitleProps) {
  return (
    <h3
      className={cn(
        'transition-all duration-300 ease-out font-sans text-xl min-h-6 line-clamp-1',
        featured ? 'text-lg' : 'text-md',
        shouldShowHoverEffects ? 'text-gray-900' : 'text-gray-500'
      )}
    >
      {title}
    </h3>
  );
}
